export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
